<script setup>
import { computed } from "vue";

const props = defineProps(["icon", "size", "color"]);

const isSymbol = computed(() => props.icon.startsWith("sym_"));

const parsedIcon = computed(() => {
    if (!isSymbol.value) return props.icon;

    const parts = props.icon.split("_");
    const style = parts[1];
    const name = parts.slice(2).join("_");

    const styleMap = {
        r: "material-symbols-rounded",
        o: "material-symbols-outlined",
        s: "material-symbols-sharp",
    };

    return {
        class: styleMap[style] || "material-symbols-rounded",
        name,
    };
});
</script>

<template>
    <span
        v-if="isSymbol"
        :class="parsedIcon.class"
        :style="{
            fontSize: size ? size + 'px' : '24px',
            color: color || 'inherit',
        }"
    >
        {{ parsedIcon.name }}
    </span>
    <v-icon v-else :size="size" :color="color">
        {{ icon }}
    </v-icon>
</template>
